
import { Component, Vue, Prop, PropSync, Ref, Emit, Watch } from "vue-property-decorator";
import { ElForm } from "element-ui/types/form";

import { getPulseTongueRelation, editPulseTongueRelation } from "@/api/consultation";
import { getPhysiqueNameList } from "@/api/tongue";

@Component({ name: 'tongue-components-pulseAssociationDialog' })
export default class PulseAssociationDialog extends Vue {
  @PropSync("dialogVisible") visible!: boolean;
  @Ref("pulseFormRef") pulseFormRef !: ElForm;
  @Prop() phyId: string | number;
  @Prop() symptomName: string;
  @Prop() physiqueName: string;
  @Prop() pulseOptions: Array<any>;

  physiqueNameOptions = [];

  pulseDialogFormRules = {
    physiqueName: { required: true, message: "请选择关联体质辨识", trigger: "none" },
    mainPulse: { required: true, message: "请选择主脉象", trigger: "none" },
  };

  mainPulseOptions = [
    { id: 1, name: "平脉" },
    { id: 2, name: "浮脉" },
    { id: 3, name: "洪脉" },
    { id: 4, name: "濡脉" },
    { id: 5, name: "散脉" },
    { id: 6, name: "芤脉" },
    { id: 7, name: "革脉" },
    { id: 8, name: "沉脉" },
    { id: 9, name: "伏脉" },
    { id: 10, name: "牢脉" },
    { id: 11, name: "弱脉" },
    { id: 12, name: "迟脉" },
    { id: 13, name: "缓脉" },
    { id: 14, name: "涩脉" },
    { id: 15, name: "结脉" },
    { id: 16, name: "数脉" },
    { id: 17, name: "疾脉" },
    { id: 18, name: "促脉" },
    { id: 19, name: "动脉" },
    { id: 20, name: "虚脉" },
    { id: 21, name: "细脉" },
    { id: 22, name: "微脉" },
    { id: 23, name: "代脉" },
    { id: 24, name: "实脉" },
    { id: 25, name: "滑脉" },
    { id: 26, name: "弦脉" },
    { id: 27, name: "紧脉" },
    { id: 28, name: "长脉" },
    { id: 29, name: "短脉" },
  ];
  concurrentPulseOptions = [
    { id: 1, name: "平脉" },
    { id: 2, name: "浮脉" },
    { id: 3, name: "洪脉" },
    { id: 4, name: "濡脉" },
    { id: 5, name: "散脉" },
    { id: 6, name: "芤脉" },
    { id: 7, name: "革脉" },
    { id: 8, name: "沉脉" },
    { id: 9, name: "伏脉" },
    { id: 10, name: "牢脉" },
    { id: 11, name: "弱脉" },
    { id: 12, name: "迟脉" },
    { id: 13, name: "缓脉" },
    { id: 14, name: "涩脉" },
    { id: 15, name: "结脉" },
    { id: 16, name: "数脉" },
    { id: 17, name: "疾脉" },
    { id: 18, name: "促脉" },
    { id: 19, name: "动脉" },
    { id: 20, name: "虚脉" },
    { id: 21, name: "细脉" },
    { id: 22, name: "微脉" },
    { id: 23, name: "代脉" },
    { id: 24, name: "实脉" },
    { id: 25, name: "滑脉" },
    { id: 26, name: "弦脉" },
    { id: 27, name: "紧脉" },
    { id: 28, name: "长脉" },
    { id: 29, name: "短脉" },
  ];

  pulseDialogForm = {
    symptomName: "",
    physiqueId: "",
    physiqueName: "",
    mainPulse: "",
    combinedPulseList: []
  }

  changePhysiqueInfo(val) {
    this.pulseDialogForm.physiqueName = val;
    this.pulseDialogForm.physiqueId = this.physiqueNameOptions.find(item => item.name === val)?.id;
  }

  handleClose() {
    this.pulseFormRef?.resetFields();
    this.visible = false;
    return false; // Close dialog
  }

  save() {
    this.pulseFormRef?.validate().then(() => {
      console.log("Saving pulse association:", this.pulseDialogForm);
      const { symptomName, ...other } = this.pulseDialogForm as any;
      editPulseTongueRelation({...other}).then((res) => {
        console.log("res:", res);
        this.$message.success("操作成功");
        this.handleClose();
        this.$emit("saved"); // Emit a custom event when saved
        this.$emit("refreshList");
      })

    })
  }

  cancel() {
    this.handleClose();
    return false; // Close dialog
  }

  // Method to set data from parent component
  public setDialogData(data: any) {
    Object.assign(this.pulseDialogForm, data);
  }

  @Watch("visible", { immediate: true })
  getPulseTongueRelation(){
    if (!this.visible) return;
    getPulseTongueRelation({ id: this.phyId }).then((res) => {
      this.pulseDialogForm = { ...(res.data || {}), id: this.phyId, symptomName: this.symptomName, physiqueName: this.physiqueName }
    });
  }

  @Watch("visible", { immediate: true })
  getPhysiqueNameOptions() {
    getPhysiqueNameList({physiqueNameType: 1}).then((res) => {
      this.physiqueNameOptions = res.data;
    });
  }
}
